<template>
  <el-group-title title="分包合同补充协议" class="ccui-group-wrapper">
    <template slot="groupTitle">
      <el-form
        :model="form"
        label-width="100px"
        class="ccui-form"
        style="overflow:visible;"
      >
        <div class="extend-btn">
          <el-button plain type="single-number" @click="addTable">
            新增
          </el-button>
        </div>
        <el-table
          :data="tableData"
          class="ccui-form-child-table"
          border
          max-height="99999"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            label="序号"
            type="index"
            align="center"
            fixed
          />
          <el-table-column
            :show-overflow-tooltip="true"
            prop="changeEditPerson"
            label="变更合同编制人"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.changeEditPerson"
                placeholder="请输入变更合同编制人"
                clearable
                maxlength="50"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="signDate"
            label="签订日期"
            min-width="100%"
          >
            <template slot-scope="scope">
              <el-date-picker
                type="date"
                placeholder="请选择签订日期"
                v-model="scope.row.signDate"
                style="width:100%"
                clearable
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="signPlace"
            label="签订地点"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.signPlace"
                placeholder="请输入签订地点"
                clearable
                maxlength="100"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="initContractName"
            label="原合同名称"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.initContractName"
                placeholder="请输入原合同名称"
                clearable
                maxlength="100"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="initContractCode"
            label="原合同编码"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.initContractCode"
                placeholder="请输入原合同编码"
                clearable
                maxlength="50"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="protocolCode"
            label="补充协议编号"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.protocolCode"
                placeholder="请输入补充协议编号"
                clearable
                maxlength="50"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="protocolName"
            label="补充协议名称"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.protocolName"
                placeholder="请输入补充协议名称"
                clearable
                maxlength="100"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="protocolTaxRateCode"
            label="补充税率编码"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.protocolTaxRateCode"
                placeholder="请输入补充税率编码"
                clearable
                maxlength="4"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="protocolTaxRate"
            label="补充协议税率"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.protocolTaxRate"
                placeholder="请输入补充协议税率"
                clearable
                maxlength="4"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="nowPriceIncludeTax"
            label="变更后含税金额（元）"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.nowPriceIncludeTax"
                placeholder="请输入变更后含税金额（元）"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="nowTax"
            label="变更后税额"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.nowTax"
                placeholder="请输入变更后税额"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="nowPriceExcludeTax"
            label="变更后不含税金额"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.nowPriceExcludeTax"
                placeholder="请输入变更后不含税金额"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="compileDate"
            label="补充协议编制日期"
            min-width="100%"
          >
            <template slot-scope="scope">
              <el-date-picker
                type="date"
                placeholder="请选择补充协议编制日期"
                v-model="scope.row.compileDate"
                style="width:100%"
                clearable
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="takeEffectDate"
            label="协议价格生效日期"
            min-width="100%"
          >
            <template slot-scope="scope">
              <el-date-picker
                type="date"
                placeholder="请选择协议价格生效日期"
                v-model="scope.row.takeEffectDate"
                style="width:100%"
                clearable
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="contractPerson"
            label="对方联系人"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.contractPerson"
                placeholder="请输入对方联系人"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="priceFillingMethodValue"
            label="价格填写方式值"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceFillingMethodValue"
                placeholder="请输入价格填写方式值"
                clearable
                maxlength="10"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="priceFillingMethod"
            label="价格填写方式"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceFillingMethod"
                placeholder="请输入价格填写方式"
                clearable
                maxlength="1"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="mainTermsOfContract"
            label="合同主要条款"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.mainTermsOfContract"
                placeholder="请输入合同主要条款"
                clearable
                maxlength="1000"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="remark"
            label="备注"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.remark"
                placeholder="请输入备注"
                clearable
                maxlength="500"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="isEnabled"
            label="是否最新生效"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.isEnabled"
                placeholder="请输入是否最新生效"
                clearable
                maxlength="1"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="isAdjustTaxFlag"
            label="是否手动调整税额"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.isAdjustTaxFlag"
                placeholder="请输入是否手动调整税额"
                clearable
                maxlength="1"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="contractState"
            label="合同状态"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.contractState"
                class="ccui-form-longInput"
                placeholder="请选择合同状态"
              >
                <el-option label="未提交" value="01"></el-option>
                <el-option label="审核中" value="02"></el-option>
                <el-option label="审核通过" value="03"></el-option>
                <el-option label="审核通过" value="04"></el-option>
                <el-option label="审核退回" value="05"></el-option>
                <el-option label="审批追回" value="6"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="checkState"
            label="审批状态"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.checkState"
                class="ccui-form-longInput"
                placeholder="请选择审批状态"
              >
                <el-option label="待审批" value="01"></el-option>
                <el-option label="审核中" value="02"></el-option>
                <el-option label="审核通过" value="03"></el-option>
                <el-option label="审批不通过" value="04"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="scaleNum"
            label="操作"
            align="center"
            width="100%"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="delTable(scope.$index, scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </template>
  </el-group-title>
</template>

<script>
export default {
  name: "materialsManagementInventory",
  props: {
    responsibility: {
      type: String,
      default: ""
    },
    taxRate: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [{ id: "1" }],
      form: {}
    };
  },
  methods: {
    // 新增
    addTable() {
      this.tableData.push({
        id: this.tableData.length + 1
      });
    },
    // 删除
    delTable(index, row) {
      this.tableData.splice(index, 1);
    }
  }
};
</script>
